import CodeIcon from "@mui/icons-material/Code";
import XIcon from "@mui/icons-material/X";
import { type FC, useMemo } from "react";

import { XShareDialog } from "~/feature/chart/components/XShareDialog";
import { getDefaultXShareSelection } from "~/feature/chart/components/XShareDialog/utils/getDefaultXShareSelection";
import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { CiteEmbedPopover } from "~/feature/citeEmbed/components/CiteEmbedPopover";
import { CITE_EMBED_ACTION } from "~/feature/citeEmbed/constants";
import { toCitationLeader } from "~/feature/citeEmbed/utils/toCitationLeader";

import * as Styled from "./ChartActions.styles";
import { useChartActions } from "./useChartActions";

export const ChartActions: FC = () => {
  const { event, markets, outcomes, selections, viewMode } = useCoreChart();
  const defaultSelection = useMemo(
    () => getDefaultXShareSelection(markets, selections, viewMode),
    [markets, selections, viewMode]
  );
  const {
    isShareOpen,
    citeAnchor,
    handleShareOnX,
    handleShareClose,
    handleCite,
    handleCiteClose,
  } = useChartActions();
  const linkedEvent = { title: event.title, slug: event.urlSlug ?? event.slug };

  return (
    <Styled.Root>
      <Styled.ActionButton onClick={handleCite} startIcon={<CodeIcon />}>
        {CITE_EMBED_ACTION.label}
      </Styled.ActionButton>

      <Styled.ActionButton onClick={handleShareOnX} startIcon={<XIcon />}>
        Share on X
      </Styled.ActionButton>

      <CiteEmbedPopover
        anchorEl={citeAnchor}
        onClose={handleCiteClose}
        event={linkedEvent}
        markets={markets}
        defaultSelection={selections}
        leader={toCitationLeader(event.leader)}
      />
      <XShareDialog
        open={isShareOpen}
        onClose={handleShareClose}
        event={linkedEvent}
        markets={markets}
        outcomes={outcomes}
        defaultSelection={defaultSelection}
      />
    </Styled.Root>
  );
};
